import { connect } from 'react-redux'
import {
  selectStripeCustomerPageUrl,
  selectStripeSubscriptionPageUrl,
} from 'selectors/sidebar_cards'
import { doFetchAccountIntegrationData } from 'actions/sidebar_cards'
import withCardDataLoading from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/withCardDataLoading'

import View from './view'

const selectFactory = (initialState, initialOwnProps) => {
  const { id: cardId } = initialOwnProps
  return state => ({
    customerPageUrl: selectStripeCustomerPageUrl(state, cardId),
    subscriptionUrls: selectStripeSubscriptionPageUrl(state, cardId),
  })
}

const performFactory = (initialState, initialOwnProps) => {
  const { provider, id: cardId } = initialOwnProps

  return dispatch => ({
    load: customerId =>
      dispatch(doFetchAccountIntegrationData(provider, cardId, customerId)),
  })
}

export default connect(selectFactory, performFactory)(
  withCardDataLoading(View, { useInAppCardView: false })
)
